








import { Component, Vue } from 'vue-property-decorator';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import Page from '@/componentsV2/molecules/Page/Page.vue';

@Component({
  components: { Page },
})
export default class PublicRemoteWaiting extends Vue {
  openEditOfferInvitationModal(props: any) {
    const { offer, index, code, businessId, locations } = props;

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'editOfferInvitation',
        hideCancelButton: true,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false,
        fullWidth: true,
        removeBackground: true,
      }),
      {
        code,
        offer,
        locations,
        businessId,
        onSuccess: (updatedOfferData: any) => {
          window.parent.postMessage(
            {
              type: 'offer:invitation:updated',
              data: {
                index,
                offer: updatedOfferData || offer,
              },
            },
            '*',
          );
        },
      },
    );
  }

  openModal(data: any) {
    const { name, props } = data;

    switch (name) {
      case 'edit-offer-invitation-modal':
        return this.openEditOfferInvitationModal(props);
      default:
        console.warn(`[PublicRemoteWaiting] Modal not supported: ${name}`);
        return;
    }
  }

  onMessage(event: MessageEvent) {
    const { type, data } = event.data;

    switch (type) {
      case 'openModal':
        return this.openModal(data);
      default:
        return;
    }
  }

  created() {
    window.addEventListener('message', this.onMessage);
    window.parent.postMessage({ type: 'iframe:modal:ready', data: {} }, '*');
  }

  beforeDestroy() {
    window.removeEventListener('message', this.onMessage);
  }
}
